import { Outlet } from "react-router-dom";
import { useSession } from "next-auth/react";

import { AdminLayoutClient } from "@/components/admin/admin-layout-client";

/**
 * `app/admin/layout.tsx`.
 *
 * The server layout read the session and redirected to `/login` or `/`; that
 * check now lives in `<RequireAdmin>`, which wraps this route. All that is left
 * here is the admin chrome itself.
 */
export function AdminLayout() {
  const { data: session } = useSession();

  return (
    <AdminLayoutClient user={session?.user}>
      <Outlet />
    </AdminLayoutClient>
  );
}